import { Bot, Images, type LucideIcon } from 'lucide-react';

// Typing an instruction and capturing a photo are the same act — recording evidence —
// so the chat composer and Observation Capture are two tools competing for one slot,
// not a panel and a dialog. A new evidence tool is one entry here plus its renderer in
// the frame; nothing else in the chat surface changes.
export type EvidenceToolId = 'chat' | 'observation';

export interface EvidenceToolDefinition {
  id: EvidenceToolId;
  label: string;
  switchTitle: string;
  icon: LucideIcon;
}

export const EVIDENCE_TOOLS: readonly EvidenceToolDefinition[] = [
  { id: 'chat', label: 'Chat', switchTitle: 'Switch to Chat', icon: Bot },
  {
    id: 'observation',
    label: 'Observation Capture',
    switchTitle: 'Switch to Observation Capture',
    icon: Images,
  },
];

export function evidenceTool(id: EvidenceToolId): EvidenceToolDefinition {
  const found = EVIDENCE_TOOLS.find((tool) => tool.id === id);
  if (!found) throw new Error(`Unknown evidence tool: ${id}`);
  return found;
}
